import React from 'react';
import cn from 'clsx';

interface CustomModalProps {
  shouldCloseOnEsc?: boolean;
  children: React.ReactNode;
  onClose?: (e: any) => void;
  addClassName?: string;
  shouldCloseOnOverlayClick?: boolean;
  onOverlayClick?: (e: any) => void;
  shouldCloseOnOverlayCallback?: (e: any) => void;
}

const CustomModal = (props: CustomModalProps) => {
  const {
    children,
    onClose,
    addClassName,
    shouldCloseOnEsc,
    onOverlayClick,
    shouldCloseOnOverlayClick,
    shouldCloseOnOverlayCallback,
  } = props;

  return (
    <div
      id="ModalContainer"
      className="z-[100] flex items-center justify-center w-full h-full fixed top-0 left-0 bg-opacity-50"
    >
      <div
        id="overLay"
        className={cn(
          'modalOverLay absolute top-0 left-0 w-full h-full bg-[#0000007f]',
          'dark:bg-[#000000d9]',
        )}
        onClick={e => {
          if (shouldCloseOnOverlayClick) {
            onClose && onClose(e);
            onOverlayClick && onOverlayClick(e);
          } else
            shouldCloseOnOverlayCallback && shouldCloseOnOverlayCallback(e);
        }}
      />
      {children}
    </div>
  );
};

export default CustomModal;
